/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import QuestionDetailsDto from './QuestionDetailsDto';

/**
 * The PageDetailsDto model module.
 * @module model/PageDetailsDto
 * @version v0
 */
class PageDetailsDto {
    /**
     * Constructs a new <code>PageDetailsDto</code>.
     * @alias module:model/PageDetailsDto
     */
    constructor() { 
        
        PageDetailsDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PageDetailsDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PageDetailsDto} obj Optional instance to populate.
     * @return {module:model/PageDetailsDto} The populated <code>PageDetailsDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PageDetailsDto();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('category_id')) {
                obj['category_id'] = ApiClient.convertToType(data['category_id'], 'Number');
            }
            if (data.hasOwnProperty('category_name')) {
                obj['category_name'] = ApiClient.convertToType(data['category_name'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('body')) {
                obj['body'] = ApiClient.convertToType(data['body'], 'String');
            }
            if (data.hasOwnProperty('interpretation')) {
                obj['interpretation'] = ApiClient.convertToType(data['interpretation'], 'String');
            }
            if (data.hasOwnProperty('video_link')) {
                obj['video_link'] = ApiClient.convertToType(data['video_link'], 'String');
            }
            if (data.hasOwnProperty('audio_link')) {
                obj['audio_link'] = ApiClient.convertToType(data['audio_link'], 'String');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
            if (data.hasOwnProperty('created_by')) {
                obj['created_by'] = ApiClient.convertToType(data['created_by'], 'String');
            }
            if (data.hasOwnProperty('updated_by')) {
                obj['updated_by'] = ApiClient.convertToType(data['updated_by'], 'String');
            }
            if (data.hasOwnProperty('questions')) {
                obj['questions'] = ApiClient.convertToType(data['questions'], [QuestionDetailsDto]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PageDetailsDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PageDetailsDto</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
            throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
        }
        // ensure the json data is a string
        if (data['category_name'] && !(typeof data['category_name'] === 'string' || data['category_name'] instanceof String)) {
            throw new Error("Expected the field `category_name` to be a primitive type in the JSON string but got " + data['category_name']);
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['body'] && !(typeof data['body'] === 'string' || data['body'] instanceof String)) {
            throw new Error("Expected the field `body` to be a primitive type in the JSON string but got " + data['body']);
        }
        // ensure the json data is a string
        if (data['interpretation'] && !(typeof data['interpretation'] === 'string' || data['interpretation'] instanceof String)) {
            throw new Error("Expected the field `interpretation` to be a primitive type in the JSON string but got " + data['interpretation']);
        }
        // ensure the json data is a string
        if (data['video_link'] && !(typeof data['video_link'] === 'string' || data['video_link'] instanceof String)) {
            throw new Error("Expected the field `video_link` to be a primitive type in the JSON string but got " + data['video_link']);
        }
        // ensure the json data is a string
        if (data['audio_link'] && !(typeof data['audio_link'] === 'string' || data['audio_link'] instanceof String)) {
            throw new Error("Expected the field `audio_link` to be a primitive type in the JSON string but got " + data['audio_link']);
        }
        // ensure the json data is a string
        if (data['created_by'] && !(typeof data['created_by'] === 'string' || data['created_by'] instanceof String)) {
            throw new Error("Expected the field `created_by` to be a primitive type in the JSON string but got " + data['created_by']);
        }
        // ensure the json data is a string
        if (data['updated_by'] && !(typeof data['updated_by'] === 'string' || data['updated_by'] instanceof String)) {
            throw new Error("Expected the field `updated_by` to be a primitive type in the JSON string but got " + data['updated_by']);
        }
        if (data['questions']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['questions'])) {
                throw new Error("Expected the field `questions` to be an array in the JSON data but got " + data['questions']);
            }
            // validate the optional field `questions` (array)
            for (const item of data['questions']) {
                QuestionDetailsDto.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
PageDetailsDto.prototype['id'] = undefined;

/**
 * @member {String} type
 */
PageDetailsDto.prototype['type'] = undefined;

/**
 * @member {Number} category_id
 */
PageDetailsDto.prototype['category_id'] = undefined;

/**
 * @member {String} category_name
 */
PageDetailsDto.prototype['category_name'] = undefined;

/**
 * @member {String} title
 */
PageDetailsDto.prototype['title'] = undefined;

/**
 * @member {String} body
 */
PageDetailsDto.prototype['body'] = undefined;

/**
 * @member {String} interpretation
 */
PageDetailsDto.prototype['interpretation'] = undefined;

/**
 * @member {String} video_link
 */
PageDetailsDto.prototype['video_link'] = undefined;

/**
 * @member {String} audio_link
 */
PageDetailsDto.prototype['audio_link'] = undefined;

/**
 * @member {Boolean} enabled
 */
PageDetailsDto.prototype['enabled'] = undefined;

/**
 * @member {Date} created_at
 */
PageDetailsDto.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
PageDetailsDto.prototype['updated_at'] = undefined;

/**
 * @member {String} created_by
 */
PageDetailsDto.prototype['created_by'] = undefined;

/**
 * @member {String} updated_by
 */
PageDetailsDto.prototype['updated_by'] = undefined;

/**
 * @member {Array.<module:model/QuestionDetailsDto>} questions
 */
PageDetailsDto.prototype['questions'] = undefined;






export default PageDetailsDto;

